import { AnyAction } from 'redux'
import { GET_REPORTS, FETCHING } from '../constants/actionTypes'
import { UserStatisticsProps } from '../../interfaces/reports'

export interface ReportsStateProps {
  fetching: boolean
  userStatistics: UserStatisticsProps | null
}

const initialState: ReportsStateProps = {
  fetching: false,
  userStatistics: null,
}

const reportsReducer = (
  state = initialState,
  action: AnyAction
): ReportsStateProps => {
  switch (action.type) {
    case FETCHING:
      return { ...state, fetching: action.payload }

    case GET_REPORTS:
      return { ...state, userStatistics: action.payload }

    default:
      return state
  }
}

export default reportsReducer
